import { WidgetFormConfigBase } from '@juvare/common-form-ui/WidgetForm';
import { Rule } from '@juvare/common-form-ui/WidgetForm/types';
import { requireAnyOrgPermission, requireAnySystemPermission } from '@juvare/contact-management/backend/features/permissions/shared';
import { WidgetOrganizationSharingConfig } from '@juvare/contact-management/ui/features/forms';
import { UserState } from '@juvare/platform-sdk-react/types';
import { TFunction } from 'i18next';

export function getHanFormConfigRules(
    t: TFunction<'healthAlerts'>,
    userState?: UserState,
): Rule<WidgetFormConfigBase & WidgetOrganizationSharingConfig>[] {
    return [
        {
            // TODO remove with new contact-management release
            type: 'disableNotVisibleOrganizationsInOrganizationSharing',
            label: t('rules.disableNotVisibleOrganizations'),
            applyRule: (config: WidgetFormConfigBase & WidgetOrganizationSharingConfig) => {
                config.disableNotVisible = !requireAnySystemPermission(userState, 'view-invisible-organizations');
            },
        },
        {
            type: 'showOnlyForAccountAdministrators',
            label: t('rules.showOnlyForAccountAdministrators'),
            applyRule: (config) => {
                const isAdministrator =
                    requireAnySystemPermission(userState, 'manage-accounts') || requireAnyOrgPermission(userState, 'manage-members');

                if (!isAdministrator) {
                    config.hidden = true;
                }
            },
        },
    ];
}
